import React, {Fragment} from 'react';
import Select from './../Select';
import {postData} from "../../../utils/request";
import PropsProxy from "../../layout/PropsProxy";

let locations = null;

class PagonyPickupPoint extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            locations: locations
        }
    }

    componentDidMount() {
        if (!this.state.locations) {
            this.loadValues();
        }
    }

    loadValues = async () => {
        const response = await postData({
            action: "PagonyPickupPoint.getPickupPoints",
            resptype: "json"
        });
        locations = response.data;
        this.setState({
            locations
        });
    }

    setFieldValue = (field, value) => {
        this.props.saveChanges && this.props.saveChanges(field, value);
    }

    getProps = (name) => {
        let props = {};
        if (this.props.getFieldProps) {
            props = this.props.getFieldProps((this.props.name ? this.props.name + '.' : '') + name);
        }
        const disabled = this.props.disabled;//Array.isArray(this.props.disabled) ? this.props.disabled : [this.props.disabled];
        props.disabled = (!Array.isArray(disabled) && disabled) || (Array.isArray(disabled) && disabled.indexOf(name) !== -1);
        return props;
    }

    getFields = () => {
        return {
            ...this.props.fields,
            address: <div className="col-sm-12">
                <Select
                    {...this.getProps("pickuppoint")}
                    options={(locations || []).map((point) => ({
                        value: point.id,
                        label: point.name + " (" + point.address.postcode + ", " + point.address.city + " " + point.address.address + ")"
                    }))}
                    objectValue={false}
                    required={true}
                    storeType="local"
                    label="Átvevőpont"
                    isLoading={this.state.isLoading}
                    saveChanges={(field, value) => this.setFieldValue("pickuppoint", value)}
                    value={(this.props.value && this.props.value.pickuppoint) || null}
                    valueKey="value"
                    labelKey="label"
                />
            </div>
        }
    }

    render() {
        const fields = this.getFields();
        if (React.Children.count(this.props.children)) {
            return <PropsProxy fields={this.getFields()}>
                {this.props.children}
            </PropsProxy>
        } else {
            return <Fragment>
                {fields.address}
            </Fragment>;
        }
    }

}

export default PagonyPickupPoint;